import { mdiChartArc } from '@mdi/js'

export default [
  {
    title: 'Menu.Reports',
    icon: mdiChartArc,
    resource: 'all',
    children: [
      {
        to: 'reports',
        title: 'Menu.Reports',
        resource: 'all',
        action: 'can_see_reports_menu',
      },
    ],
  },
]
